package kz.dentalcrm.app.core.utils

import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder
import kotlinx.serialization.json.JsonDecoder
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.booleanOrNull
import kotlinx.serialization.json.intOrNull

object FlexibleBooleanSerializer : KSerializer<Boolean?> {
    override val descriptor: SerialDescriptor =
        PrimitiveSerialDescriptor("FlexibleBoolean", PrimitiveKind.BOOLEAN)

    override fun deserialize(decoder: Decoder): Boolean? {
        val jsonDecoder = decoder as? JsonDecoder
            ?: return decoder.decodeBoolean()

        val element = jsonDecoder.decodeJsonElement()
        if (element !is JsonPrimitive) return null

        return element.booleanOrNull
            ?: element.intOrNull?.let { it != 0 }
    }

    override fun serialize(encoder: Encoder, value: Boolean?) {
        if (value != null) {
            encoder.encodeBoolean(value)
        }
    }
}
